import Vue from 'vue'
import VueI18n from 'vue-i18n'
import customZhCn from './lang/zh-CN'
import customEnUs from './lang/en-US'
import customKoKr from './lang/ko-KR'
import zhCnLocale from 'view-design/src/locale/lang/zh-CN'
import enUsLocale from 'view-design/src/locale/lang/en-US'
import koKuLocale from 'view-design/src/locale/lang/ko-KR'

Vue.use(VueI18n)

// 自动根据浏览器系统语言设置语言
const navLang = navigator.language
const localLang = (navLang === 'zh-CN' || navLang === 'en' || navLang === 'ko') ? navLang : false
let lang = 'zh-CN'
switch (localLang) {
  case 'zh-CN':
    lang = 'zh-CN'
    break
  case 'en':
    lang = 'en-US'
    break
  case 'ko':
    lang = 'ko-KR'
    break
}
Vue.config.lang = lang

// vue-i18n 6.x+写法
Vue.locale = () => {}
const messages = {
  'zh-CN': Object.assign(zhCnLocale, customZhCn),
  'en-US': Object.assign(enUsLocale, customEnUs),
  'ko-KR': Object.assign(koKuLocale, customKoKr)
}
const i18n = new VueI18n({
  locale: lang,
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/locale/index.js